<template>
  <CustomTooltip
    text="Record"
  >
    <TooltipBounceButton
      v-bind="$attrs"
      store-key="start-recording-button:clicked"
      content="Click to record"
      side="left"
      class="tw:inline-block"
    >
      <div class="tw:size-[30px] tw:bg-red-500 tw:rounded-full tw:inline-block" />
    </TooltipBounceButton>
  </CustomTooltip>
</template>

<script setup>
import CustomTooltip from '@/components/custom-tooltip.vue'
import TooltipBounceButton from '../../../common/tooltip-bounce-button.vue'

defineOptions({
  inheritAttrs: false,
})
</script>
